"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const _ActionTypes = require("./actionTypes");
const _Actions = require("./actions");
const errorHandling_1 = require("../../../utils/errorHandling");
function default_1(namespace) {
    const ActionTypes = _ActionTypes.default(namespace);
    const Actions = _Actions.default(namespace);
    function convert(action$, store, { ajax, getToken, baseUrl }) {
        return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.GENERATE_PREVIEW_REQUEST), (0, operators_1.mergeMap)((request) => ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'POST',
            url: `${baseUrl}api/files/convert/preview/${request.payload}`
        }).pipe((0, operators_1.mergeMap)((xhr) => {
            return (0, rxjs_1.of)(Actions.generatePreviewSuccess(xhr.response.data.uuid, request.payload, xhr.response.data.status));
        }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.generatePreviewFailure((0, errorHandling_1.parseAjaxErrorResponse)(e), request.payload))))));
    }
    return { convert };
}
exports.default = default_1;
//# sourceMappingURL=epics.js.map